"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareTransaction = exports.createTransaction = void 0;
const bignumber_js_1 = require("bignumber.js");
const typhonjs_1 = require("@stricahq/typhonjs");
const jsHelpers_1 = require("@ledgerhq/coin-framework/bridge/jsHelpers");
const js_buildTransaction_1 = require("./js-buildTransaction");
/**
 * Create an empty transaction
 *
 * @returns {Transaction}
 */
const createTransaction = () => ({
    family: "cardano",
    mode: "send",
    amount: new bignumber_js_1.BigNumber(0),
    recipient: "",
    useAllAmount: false,
    fees: new bignumber_js_1.BigNumber(0),
});
exports.createTransaction = createTransaction;
/**
 * Prepare transaction before checking status
 *
 * @param {Account} a
 * @param {Transaction} t
 */
const prepareTransaction = (a, t) => __awaiter(void 0, void 0, void 0, function* () {
    let patch = {};
    try {
        const cardanoTransaction = yield (0, js_buildTransaction_1.buildTransaction)(a, t);
        const transactionFees = cardanoTransaction.getFee();
        const transactionAmount = t.subAccountId
            ? t.amount
            : cardanoTransaction
                .getOutputs()
                .filter(o => !(o.address instanceof typhonjs_1.address.BaseAddress) ||
                !(o.address.paymentCredential.type === typhonjs_1.types.HashType.ADDRESS) ||
                o.address.paymentCredential.bipPath === undefined)
                .reduce((total, o) => total.plus(o.amount), new bignumber_js_1.BigNumber(0));
        patch = { fees: transactionFees, amount: transactionAmount };
    }
    catch (error) {
        patch = { fees: new bignumber_js_1.BigNumber(0), amount: t.amount };
    }
    return (0, jsHelpers_1.defaultUpdateTransaction)(t, patch);
});
exports.prepareTransaction = prepareTransaction;
//# sourceMappingURL=js-transaction.js.map